interface HashType {
  [key: string]: string;
}

export const INACTIVE_CART_MESSAGE = 'Current user does not have an active cart.';
export const COULD_NOT_FIND_CART_MESSAGE = 'Could not find a cart with ID';

// Full message: Unable to place order: Phương thức giao hàng không có sẵn. Vui lòng thử lại.
export const UNAVAILABLE_SHIPPING_METHOD = 'Unable to place order';
export const MISSING_SHIPPING_ADDRESS = 'The shipping address is missing';

export const CART_ITEM_NOT_FOUND_MESSAGE = "Cart doesn't contain the";
export const ORDER_ALREADY_PLACED = 'Đơn hàng đã được thanh toán bởi cùng một tài khoản. Trở về trang chủ để tạo một đơn hàng mới';
export const  hashCartToastMessage: HashType = {
  [INACTIVE_CART_MESSAGE]: ORDER_ALREADY_PLACED
}
